import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import API from "../config/axios";
import { api_paths } from "../config/api.paths";
// import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { SET_LOADING } from "../redux/user";
import DefaultPhoto from "../assets/images/committee/DefaultPhoto.svg";
import LeftArrow from "../assets/images/committee/ArrowLeft.svg";
import { useNavigate } from "react-router-dom";

const IMG_PATH = process.env.REACT_APP_IMAGE_BASEURL || "";

const PastPresident = () => {
  const [pastpresidents, setPastPresidents] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchPastPresidents = async () => {
    dispatch(SET_LOADING(true));
    try {
      const response = await API.get(api_paths.member.PAST_PRESIDENTS.GET_LIST);
      // console.log("past president List:", response.data);

      const data = response.data?.payload?.data || [];
      setPastPresidents(data);
      dispatch(SET_LOADING(false));
    } catch (error) {
      console.error("Error fetching events:", error);
    } finally {
      dispatch(SET_LOADING(false));
    }
  };

  useEffect(() => {
    fetchPastPresidents();
    //eslint-disable-next-line
  }, []);

  return (
    <Container className="py-5">
      <img
        className="cursor-pointer"
        src={LeftArrow}
        alt="back"
        onClick={() => {
          navigate(-1);
        }}
      />
      <Row className="mb-4">
        <Col lg={12}>
          <div className="rsvp-header text-center">
            <h1 className="inter-bold h1">Past Presidents</h1>
            <p>Honoring the leaders who shaped our community</p>
          </div>
        </Col>
      </Row>

      <Row>
        {pastpresidents.map((president) => (
          <Col
            key={president._id}
            xl={3}
            lg={4}
            md={6}
            sm={12}
            className="mb-4"
          >
            {/* <Link
              to={`/past-president/${president._id}`}
              className="text-decoration-none text-dark d-block"
            > */}
            <Card className="h-100 border-0 past-president-card">
              <Card.Img
                variant="top"
                src={
                  president?.picture_path
                    ? `${IMG_PATH}${president?.picture_path}`
                    : DefaultPhoto
                }
                className="card-img-fixed"
              />

              <Card.Body>
                <Card.Title className="mb-0 fw-semibold f-16 text-main">
                  {president.name}
                </Card.Title>

                <p className="commitee-post mb-0">
                  {president?.start_year}
                  {president?.end_year && <>- {president?.end_year}</>}
                </p>

                {/* <Card.Text>{president?.description}</Card.Text> */}
              </Card.Body>
            </Card>
            {/* </Link> */}
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default PastPresident;
